module.exports = __webpack_public_path__ + "static/media/RB_Red_RGB.0345a9b6.svg";